"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * 支持图标的指示条在上方的 Tabs 组件
 */
var SceneIconTabs = function SceneIconTabs(_a) {
  var className = _a.className,
    style = _a.style,
    tabs = _a.tabs,
    defaultActiveKey = _a.defaultActiveKey;
  var _b = (0, _react.useState)(function () {
      var _a;
      return defaultActiveKey !== undefined ? defaultActiveKey : (_a = tabs === null || tabs === void 0 ? void 0 : tabs[0]) === null || _a === void 0 ? void 0 : _a.key;
    }),
    activeKey = _b[0],
    setActiveKey = _b[1];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(className, 'comp-scene-icon-tabs'),
    style: style
  }, /*#__PURE__*/_react["default"].createElement("ul", null, tabs === null || tabs === void 0 ? void 0 : tabs.map(function (tab, idx) {
    var _a;
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: (_a = tab.key) !== null && _a !== void 0 ? _a : idx,
      className: (0, _classnames["default"])({
        active: String(activeKey) === String(tab.key)
      }),
      onClick: function onClick() {
        setActiveKey(tab.key);
      }
    }, tab.label);
  })), tabs === null || tabs === void 0 ? void 0 : tabs.map(function (tab, idx) {
    var _a;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: (_a = tab.key) !== null && _a !== void 0 ? _a : idx,
      className: (0, _classnames["default"])('comp-tab__panel', {
        active: String(activeKey) === String(tab.key)
      })
    }, tab.children);
  }));
};
var _default = exports["default"] = SceneIconTabs;